import { createContext, useContext, useMemo } from 'react'
import ArtDirectionWrapper from '@bluheadless/ui/src/particles/art-direction/art-direction-wrapper'
import { useConfig } from '../config'

const ImageContext = createContext()

const ImageProvider = ({ children, sizes }) => {
	const { sizes: parentSizes = 100 } = useImageContext()

	const value = useMemo(
		() => ({
			sizes: sizes ? (parentSizes / 100) * sizes : undefined,
		}),
		[sizes, parentSizes]
	)

	return <ImageContext.Provider value={value}>{children}</ImageContext.Provider>
}

export default ImageProvider

export const useImageContext = () => useContext(ImageContext) ?? {}

export const ImageResponsiveProvider = ({ children }) => {
	const {
		images: { responsiveSizes = {} },
	} = useConfig()

	const responsiveProps = useMemo(() => {
		const responsiveProps = Object.entries(responsiveSizes).reduce(
			(acc, [key, value]) => ({ ...acc, [key]: { sizes: value } }),
			{}
		)

		return Object.entries(responsiveProps).length > 0 ? responsiveProps : { xs: {} }
	}, [responsiveSizes])

	return (
		<ArtDirectionWrapper responsiveProps={responsiveProps} ChildComponent={ImageProvider}>
			{children}
		</ArtDirectionWrapper>
	)
}
